// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content_n6wLM"};